import { atom, useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'

const loadingState = atom<boolean>({
  key: 'loadingState',
  default: false
})

export const useLoadingState = ()=>useRecoilState(loadingState)
export const useLoadingValue = ()=>useRecoilValue(loadingState)
export const useSetLoadingState = ()=>useSetRecoilState(loadingState)
